import { TPositionFormItem } from "./types";

export type TTrainingLicenseDisplayState =
  | "assigned"
  | "available"
  | "training_required"
  | "no_free";

type TTrainingLicenseStateParams = {
  positionId?: string | null;
  educationTraining?: string;
  licenseAssigned: boolean;
  licenseFreeCount: number;
};

export const getTrainingLicenseDisplayState = ({
  positionId,
  educationTraining,
  licenseAssigned,
  licenseFreeCount,
}: TTrainingLicenseStateParams): TTrainingLicenseDisplayState | null => {
  if (!positionId) {
    return null;
  }

  if (licenseAssigned) {
    return "assigned";
  }

  if (licenseFreeCount > 0) {
    return "available";
  }

  const needsTraining =
    educationTraining === "isNotTrained" ||
    educationTraining === "processLearning";

  if (needsTraining || !educationTraining) {
    return "training_required";
  }

  return "no_free";
};

/** Блокировка «Отправить на проверку»: должность выбрана, лицензия не назначена, нет свободных. */
export const hasLicenseSendBlock = (
  positions: TPositionFormItem[] = [],
): boolean =>
  positions.some(
    (position) =>
      Boolean(position.position?.value) &&
      !position.licenseAssigned &&
      position.licenseFreeCount <= 0,
  );
